import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ImpactSection } from './components/ImpactSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { TasksSection } from './components/TasksSection';
import { ComparisonSection } from './components/ComparisonSection';
import { TrustSection } from './components/TrustSection';
import { TeamSection } from './components/TeamSection';
import { CTAFooter } from './components/CTAFooter';
import { FAQSection } from './components/FAQSection';
export function App() {
  useEffect(() => {
    document.title = 'Bedford | Your next-gen operations partner for benefits enrollment';
    const setMetaTag = (attrName: string, attrValue: string, content: string) => {
      let element = document.querySelector(`meta[${attrName}="${attrValue}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attrName, attrValue);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    setMetaTag('name', 'description', 'Bedford provides a dedicated team of operations professionals to handle your enrollments — installing groups, updating carrier portals, and managing Employee Navigator accurately and on time.');
    setMetaTag('property', 'og:title', 'Bedford | Your next-gen operations partner');
    setMetaTag('property', 'og:description', 'Bedford provides a dedicated team of operations professionals to handle your enrollments — installing groups, updating carrier portals, and managing Employee Navigator accurately and on time.');
    setMetaTag('property', 'twitter:title', 'Bedford | Your next-gen operations partner');
    setMetaTag('property', 'twitter:description', 'Bedford provides a dedicated team of operations professionals to handle your enrollments — installing groups, updating carrier portals, and managing Employee Navigator accurately and on time.');
  }, []);
  return <div className="min-h-screen bg-gray-100 font-body text-slate-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        {/* 1. Who we are + what we do */}
        <HeroSection data-id="element-3" />
        <ImpactSection data-id="element-4" />
        <HowItWorksSection data-id="element-5" />

        {/* 2. Value Proposition + Credentials */}
        {/*<ProblemSection />*/}
        <TeamSection data-id="element-6" />

        {/* 4. Social Proof */}
        {/*<TasksSection />*/}

        {/* 3. How we're different */}
        <TrustSection data-id="element-7" />
        <ComparisonSection data-id="element-8" />
        <FAQSection data-id="element-9" />
      </main>
      <CTAFooter data-id="element-10" />
    </div>;
}